export type AppConfig = {
  API_BASE_URL?: string;
};

export async function loadConfig(): Promise<AppConfig> {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (!res.ok) return {};
    return (await res.json()) as AppConfig;
  } catch {
    return {};
  }
}

export function getBackendBaseUrl(cfg?: AppConfig): string {
  const envUrl = (process.env.REACT_APP_API_URL || '').trim();
  if (envUrl) return envUrl.replace(/\/$/, '');
  if (cfg?.API_BASE_URL) return cfg.API_BASE_URL.replace(/\/$/, '');
  return 'https://getaws.alpha-pilot.net';
}


